"use client";

import Link from "next/link";
import { ArrowLeft } from "lucide-react";

import { cn } from "@/lib/utils";

const BACK_LINK_CLASS =
  "inline-flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors";

type BackLinkProps = {
  children: React.ReactNode;
  className?: string;
} & (
  | { href: string; onClick?: never }
  | { href?: never; onClick: () => void }
);

/** Canonical page-level “Back to …” control. Use this instead of ghost/outline buttons. */
export function BackLink({ href, onClick, children, className }: BackLinkProps) {
  const classes = cn(BACK_LINK_CLASS, className);
  if (href) {
    return (
      <Link href={href} className={classes}>
        <ArrowLeft className="h-4 w-4" />
        {children}
      </Link>
    );
  }
  return (
    <button type="button" onClick={onClick} className={classes}>
      <ArrowLeft className="h-4 w-4" />
      {children}
    </button>
  );
}
